(function() {
    /* Delay loading of third party scripts
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    var timeout = 8000;
    if(localStorage.getItem('firstVisit') != null) {
        timeout = 1500;
    } else {
        localStorage.setItem('firstVisit', "true");
    }
    document.addEventListener('DOMContentLoaded', function() {
        document.addEventListener('scroll', loadScripsOnEvent);
        document.addEventListener('mousemove', loadScripsOnEvent);
        document.addEventListener('touchstart', loadScripsOnEvent);
        // fallback so scripts load if no interaction for x time (shorter wait after first visit as many site resources will already be cached)
        setTimeout(function() {
            if (!window.scriptsLoaded) {
                loadScripts();
            }
        }, timeout);
    });
    
    function loadScripsOnEvent(event) {
        if (!window.scriptsLoaded) {
            loadScripts();
            event.currentTarget.removeEventListener(event.type, loadScripsOnEvent);
        }
    }
    
    function loadScripts () {
        if (window.scriptsLoaded) {
            return false;
        }
        window.scriptsLoaded = true;
    }

})()